<template>
  <PublicPopup
    ref="PopupRef"
    type="fullScreen"
    :height="90"
    position="bottom"
    @close="emit('close')"
  >
    <template #content>
      <div class="download-guide-popup">
        <div class="header-container">
          <p class="title">Como usar PWA?</p>
          <van-icon name="close" class="close-icon" @click="handlePopupClose" />
        </div>

        <div class="content-card-title">
          <p class="title">1. Pulsa el boton Aniadirmenu</p>
          <span class="content">
            Abre
            <span class="web-name">{{ t('app.name') }}</span>
            en la aplicacion Chrome y pulsa el icono del
          </span>
        </div>
        <div class="content-card-images chxy-row-c-c">
          <img
            :src="getImageUrlWithCDN_TEST('/home/download_guide_1.webp', 'local')"
            class="images"
          />
        </div>

        <div class="content-card-title">
          <p class="title">2. Pulsa Anadir a la pantalla de inicio</p>
          <span class="content">
            En la lista mostrada, pulsa "Anadir a la pantalla de iniciopara completar la adicion. Si
            no encuentras el boton, prueba adesplazar la pantalla hacia abajo.
          </span>
        </div>
        <div class="content-card-images chxy-row-c-c">
          <img
            :src="getImageUrlWithCDN_TEST('/home/download_guide_2.webp', 'local')"
            class="images"
          />
        </div>
      </div>
    </template>
  </PublicPopup>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const PopupRef = ref(null)
const open = () => {
  nextTick(() => {
    PopupRef.value.open()
  })
}
const handlePopupClose = () => {
  PopupRef.value.close()
}

const emit = defineEmits(['close'])

defineExpose({
  open,
})
</script>

<style lang="scss" scoped>
.download-guide-popup {
  padding: 10px;
  width: 100%;
  height: 100%;
  background-color: var(--download-guide-popup-bg);

  .header-container {
    position: relative;
    width: 100%;
    height: 48px;
    font-size: 16px;
    text-align: center;
    line-height: 48px;

    .title {
      color: var(--popup-primary-title);
    }
    .close-icon {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 24px;
      color: var(--download-guide-popup-close-icon);
    }
  }

  .content-card-title {
    margin-top: 12px;

    .title {
      font-size: 14px;
      color: var(--download-guide-popup-content-label);
    }

    .content {
      font-size: 12px;
      color: var(--download-guide-popup-content-text);

      .web-name {
        color: var(--download-guide-popup-content-web);
      }
    }
  }

  .content-card-images {
    margin-top: 12px;

    .images {
      width: 90%;
    }
  }
}
</style>
